import React, { useState, useRef } from "react"
import { makeStyles } from "@mui/styles"
import { TextField } from "@mui/material"
import { Popover, Button, Stack } from "@mui/material"
import CustomIntervalCalendar from "../Calendar/CustomIntervalCalendar"
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation"
import dayjs from "dayjs"

const useStyles = makeStyles({
  input: {
    fontSize: "16px",
    paddingBottom: 8
  }
})

const FormikIntervalCalendarField = ({
  options = [],
  handleChange,
  afterChangeOption,
  date = null,
  startDate,
  label = "",
  hasError = false,
  errorText = null,
  maxWidth,
  sx = {},
  popoverSettings = {},
  showSelectionInBetween = true
}) => {

  const classes = useStyles()

  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const anchorRef = useRef(null)

  const handleOpen = () => {if (anchorRef.current) setAnchorEl(anchorRef.current)}
  const handleClose = () => setAnchorEl(null)

  return (
    <Stack direction="column" width="100%" alignItems="stretch" ref={anchorRef}>
        <TextField
          error={hasError}
          helperText={errorText}
          label={label}
          variant={"standard"}
          value={date ? dayjs(date).format("DD/MM/YYYY") : "-"}
          readOnly
          fullWidth
          onClick={handleOpen}
          sx={{
            cursor: "none",
            caretColor: "transparent",
            maxWidth: maxWidth || "unset",
            ...sx
          }}
          InputProps={{
            endAdornment: (
              <Button
                aria-describedby={"popover-calendar"}
                onClick={handleOpen}
                sx={{
                  padding: 0,
                  minWidth: "fit-content"
                }}
              >
                <InsertInvitationIcon size={24} sx={{ color: "#0000008a" }} />
              </Button>
            ),
            inputProps: {
              className: classes.input
            }
          }}
        >
        </TextField>
      <Popover
        id={"popover-calendar"}
        open={Boolean(open)}
        anchorEl={anchorEl}
        onClose={handleClose}
        {...popoverSettings}
      >
        <CustomIntervalCalendar
          date={date}
          startDate={startDate}
          options={options}
          onChange={handleChange}
          afterChangeOption={afterChangeOption}
          onClose={handleClose}
          showSelectionInBetween={showSelectionInBetween}
        />
      </Popover>
    </Stack>
  )
}

export default FormikIntervalCalendarField